export default __webpack_public_path__ + "static/beian.png";